import { useContext } from "react";

import { SalesV4Context } from "../sales-v4-provider";

export const useSalesV4Context = () => {
  const context = useContext(SalesV4Context);

  if (!context) {
    throw new Error("useSalesV4Context must be used within a SalesV4Provider");
  }

  return context;
};
